import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import {
    NavBarLogo,
    NavBarShoppingCartIcon,
    NavbarSearchIcon,
    NavBarContentSearchItems,
    NavBarButton,
    LoginModal,
    LoginRegisterModal,
    MenuCategories
} from "./index";
import { config, ROLES } from '../libs/utils/Const';
import { Modal } from './index';
import $ from "jquery";

let modal = new Modal();

class NavBar extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            seller: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser')),
            vendor: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'vendor'))
        };
    }

    /*componentDidMount(){
        this.asinamentData();
    }

    asinamentData(){
        let seller = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let vendor = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'vendor'));
        this.setState({
            seller: seller,
            vendor: vendor
        });
    }*/

    toggleMenuUser = () => {
        $("#menu-user-button").click(function () {
            $(".menu-user").toggle();
            $(".menu-user-responsive").focus();
        });
    }

    renderName = () => {
        const { configReducer, sessionReducer: { user } } = this.props;
        const { seller, vendor } = this.state;
        //console.log("se puede mostar", empID);
        // console.log("in vendor", vendor);
        if (seller !== null) {
            return (
                <span className="ml-2" style={{ color: config.navBar.textColor }}>{seller.firstName} {seller.lastName}: {user.CardName}</span>
            );
        } else {
            return (
                <span className="ml-2" style={{ color: config.navBar.textColor }}>{user.CardName}</span>
            );
        }

    }

    renderClientOptionFirstNavBar = () => {
        const { configReducer, sessionReducer: { user } } = this.props;
        const { seller } = this.state;
        return (
            <ul className="navbar-nav d-none d-md-flex">
                <li className="nav-item">
                    <a className="nav-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className={config.icons.user} aria-hidden="true" style={{ color: config.navBar.iconColor }} />&nbsp;
                        <div className="marq"><span className="orig">{this.renderName()}</span></div>
                        {/* {this.renderName()} */}
                        {/*<span className="ml-2" style={{ color: config.navBar.textColor }}>{user.CardName}</span>*/}
                    </a>
                    <div className="dropdown">
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            {Object.entries(user).length !== 0 && <Link to='/subirArchivo' className="dropdown-item" >Subir archivo OC</Link>}
                            {Object.entries(user).length !== 0 && <Link to='/reports' className="dropdown-item" >Mis reportes</Link>}
                            {seller ? seller.U_FMB_Handel_Perfil !== "0" && 
                                <Link to='/myprofileSeller' className="dropdown-item" >Cambiar Contraseña</Link> 
                            : ''}
                            {Object.entries(user).length !== 0 && <Link to='/myprofile' className="dropdown-item" >Mi perfil</Link>}
                            {user.wishlist === 1 &&
                                <a className="dropdown-item" onClick={() => { configReducer.history.goBackOrder(); }}>Lista de deseos</a>}
                            {seller ? seller.U_FMB_Banner === "1" && //user.banners === "on" && 
                                <Link to='/adminBanners' className="dropdown-item" >Adm. Banners</Link>
                            :''}

                            <a className="dropdown-item" onClick={() => { configReducer.logOut(); }}>Cerrar sesión</a>
                        </div>
                    </div>
                </li>
            </ul>
        )
    };

    renderPublicOptionFirstNavBar = () => {
        return (
            <ul className="navbar-nav d-none d-md-flex">
                <li className="nav-item">
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <span onClick={() => { modal.loginModal('show') }}>Iniciar sesión</span>
                    </a>
                </li>
                {/*<li className="nav-item">
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <span onClick={() => { modal.loginRegisterModal('show') }}>Registrarse</span>
                    </a>
                </li>*/}
            </ul>
        )
    };

    renderFirstNavBar = () => {
        const { sessionReducer } = this.props;
        return (
            <nav id="navFirst" className=" ​navbar navbar-expand-sm " style={{ border: 'none', padding: 0, height: 45, background: config.navBar.backgroundColor }} >
                <ul className="navbar-nav elements">
                    <li className="nav-link menu-categories-button col-lg-4 col-md-4" style={{ color: config.navBar.textColor, cursor: 'pointer' }} >
                        <i className={config.icons.menu} style={{ color: config.navBar.iconColor, fontsize: 15 }} />
                        &nbsp;&nbsp;<label className="align-middle text-center categorias">CATEGORIAS</label>
                        <a className="navbar-brand">
                            <NavBarLogo />       
                        </a> 
                    </li>                       
                    <li className="nav-item searchItems col-lg-4 col-md-4 d-md-block" style={{ textAlign: 'center' }}>
                        <NavBarContentSearchItems className="nav justify-content-center" icon={config.icons.search} iconColor={config.navBar.iconColor} textColor={config.navBar.backgroundColor} />
                    </li>
                    <li className="nav-item ml-sm-auto d-md-flex col-lg-auto col-md-auto row shoppingSearch" id="navbarFirst" >    
                        <span >
                            <span>{sessionReducer.role === ROLES.PUBLIC ? this.renderPublicOptionFirstNavBar() : this.renderClientOptionFirstNavBar()}</span>
                        </span>
                        <span >
                            <NavbarSearchIcon
                                icon={config.icons.search}
                                iconColor={config.navBar.iconColor}
                                textColor={config.navBar.textColor}
                            />&nbsp;
                            <NavBarShoppingCartIcon
                                icon={config.icons.shoppingCart}
                                iconColor={config.navBar.iconColor}
                                textColor={config.navBar.textColor}
                            />
                        </span>                         
                    </li>
                    {/* <li className="nav-item navbarResponsive">
                        <span className="dark-blue-text"><i className={config.icons.menu}
                            style={{color: config.navBar.iconColor, fontsize: 15, paddingTop: 10}}
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent1b"
                            aria-controls="navbarSupportedContent1b" 
                            aria-expanded="false" 
                            aria-label="Toggle navigation" 

                        /></span>
                    </li> */}
                </ul>
            </nav>
            // <nav className="fixed-top navbar navbar-expand-sm navbar-dark" style={{ border: 'none', padding: 0, height: 45, background: config.navBar.backgroundColor, marginTop: 8 }}>
            //     <ul className="navbar-nav " style={{ paddingLeft: 16, paddingBottom: 16 }}>
            //         {/*title={`Categorias`}*/}
            //          <li className="nav-link menu-categories-button" style={{ color: config.navBar.textColor, cursor: 'pointer' }} > 
            //             <i className={config.icons.menu} style={{ color: config.navBar.iconColor, fontsize: 15 }} />
            //            &nbsp;&nbsp;<label className="align-middle text-center">CATEGORIAS</label>
            //         </li>
            //     </ul>
            //     <NavBarLogo />
            //     <ul className="navbar-nav  col-md-4 d-sm-block d-none  " style={{ paddingBottom: 5, marginLeft: 230, textAlign: 'center' }}>
            //         <li>
            //             <NavBarContentSearchItems className="nav justify-content-center" icon={config.icons.search} iconColor={config.navBar.iconColor} textColor={config.navBar.backgroundColor} />
            //         </li>
            //     </ul>
            //     <div className="navbar-nav ml-sm-auto d-md-flex" id="navbarFirst">
            //         <span className="mr-2 p-1">
            //             <span>{sessionReducer.role === ROLES.PUBLIC ? this.renderPublicOptionFirstNavBar() : this.renderClientOptionFirstNavBar()}</span>
            //         </span>
            //         <span className="p-1 mr-3">
            //             <NavbarSearchIcon
            //                 icon={config.icons.search}
            //                 iconColor={config.navBar.iconColor}
            //                 textColor={config.navBar.textColor}
            //             />&nbsp;
            //             <NavBarShoppingCartIcon
            //                 icon={config.icons.shoppingCart}
            //                 iconColor={config.navBar.iconColor}
            //                 textColor={config.navBar.textColor}
            //             />
            //         </span>
            //     </div>
            // </nav>
        );
    };
    renderPublicOptionMenu = () => {
        return (
            <ul className="navbar-nav mr-auto">
                <li className="nav-item" onClick={() => { modal.loginModal('show') }}>
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <span>Iniciar sesión</span>
                    </a>
                </li>
                {/*<li className="nav-item" onClick={() => { modal.loginRegisterModal('show') }}>
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <span>Registrarse</span>
                    </a>
                </li>*/}
            </ul>
        )
    };

    renderClientOptionMenu = () => {
        const { configReducer, sessionReducer: { user }, configReducer: { history } } = this.props;
        // console.log(user);
        const { seller } = this.state;
        return (
            <ul className="navbar-nav mr-auto opcmenuSecondNav"> 
                {/* <li className="nav-item">
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <i className={config.icons.user} style={{ color: config.navBar.iconColor }} aria-hidden="true" />
                        <span>&nbsp; {user.CardName}</span>
                    </a>
                </li>  */}
                <li className="nav-item" style={{ color: config.navBar.textColor }}>
                    <i className={config.icons.user} style={{ color: config.navBar.iconColor }} aria-hidden="true" />
                    <span>&nbsp; {user.CardName}</span>
                </li>

                {/* <li className="nav-item" onClick={() => { configReducer.history.goProfile(); }}>
                    <a className="nav-link" style={{color: config.navBar.textColor}}>
                        <span>Perfil</span>
                    </a>
                </li> */}
                 {/* <li className="nav-item">
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <Link to='/myprofile'style={{ color: config.navBar.textColor }}>Mi perfil</Link>
                    </a>
                </li> */}

                {Object.entries(user).length !== 0 &&
                    <li className="nav-item"  style={{ color: config.navBar.textColor }}>
                        <Link to='/subirArchivo' style={{ color: config.navBar.textColor }}>Subir archivo OC</Link>
                    </li>
                }
                {Object.entries(user).length !== 0 &&
                    <li className="nav-item"  style={{ color: config.navBar.textColor }}>
                        <Link to='/reports' style={{ color: config.navBar.textColor }}>Mis reportes</Link>
                    </li>
                }
                {Object.entries(user).length !== 0 &&
                    <li className="nav-item" style={{ color: config.navBar.textColor }}>
                        <Link to='/myprofile'style={{ color: config.navBar.textColor }}>Mi perfil</Link>
                    </li>
                }
                {/* {user.banners === 'on' ? (
                    <li className="nav-item"  >
                        <a className="nav-link" style={{ color: config.navBar.textColor }}>
                            <span>Administrador de Sliders</span>
                        </a>
                    </li>
                ) : ''} */}
                { seller ? seller.U_FMB_Handel_Perfil !== "0" && (
                    <li className="nav-item" style={{ color: config.navBar.textColor }}>
                        <Link to='/myprofileSeller' style={{ color: config.navBar.textColor }}>Cambiar Contraseña</Link>
                    </li>
                ) : ''}
                { seller ? seller.U_FMB_Banner === "1" && (//user.banners === 'on' ? (
                    <li className="nav-item" style={{ color: config.navBar.textColor }}>
                        <Link to='/adminBanners' style={{ color: config.navBar.textColor }}>Adm. Banners</Link>
                        {/* <span>Administrador de Sliders</span> */}
                    </li>
                ) : ''}
                {/* {config.aboutUs.active &&
                    <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAboutUs()}>
                        <a className="nav-link" style={{ color: config.navBar.textColor }}>
                            <span> ¿Quiénes somos? </span>
                        </a>
                    </li>} */}
                 {config.aboutUs.active &&
                    <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAboutUs()}>
                        <span> ¿Quiénes somos? </span>
                    </li>}
                {/* {config.contactUs.active &&
                    <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goContactUs()}>
                        <a className="nav-link" style={{ color: config.navBar.textColor }}>
                            <span> Contáctanos </span>
                        </a>
                    </li>} */}
                {config.contactUs.active &&
                    <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goContactUs()}>
                        <span> Contáctanos </span>
                    </li>}
                    
                <li className="nav-item" style={{ color: config.navBar.textColor }} onClick={() => { configReducer.logOut(); }}>
                    <span>Cerrar Sesión</span>
                </li>
            </ul>
        )
    };

    // Responsive
    renderSecondNavBar = () => {
        const { configReducer: { history }, sessionReducer: { user }, sessionReducer } = this.props;
        const { seller } = this.state;
        let usuario = user ? user.USERID : '';
        return (
            <div style={{ width: '100%', background: 'transparent'}}>
                <div className=' d-block d-lg-none' style={{ width: '100%'}}>
                    <nav className="navbar navbar-expand-lg navbar-two " style={{  background: config.navBar.backgroundColor }}>
                        {/* <NavBarButton iconColor={config.navBar.iconColor} icon={config.icons.menu} />   */}
                        <NavBarButton iconColor={config.navBar.iconColor} icon={config.icons.user} />  
                        <div className="collapse navbar-collapse " id="navbarSupportedContent1">
                            {sessionReducer.role === ROLES.PUBLIC ? this.renderPublicOptionMenu() : this.renderClientOptionMenu()}
                            <ul className="navbar-nav secondNavbarButton">
                                {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
                                    ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAutoGestCartsSaved()}>
                                        <span> Autogestión Clientes </span>
                                    </li>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
                                    ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goCartsSaved()}>
                                        <span> Guardados </span>
                                    </li>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
                                    ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goOrderStatus()}>
                                        <span> Mis pedidos </span>
                                    </li>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
                                    ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goSelectClient()}>
                                        <span> Mis clientes </span>
                                    </li>
                                    : "" : ""
                                }
                                {seller ? seller.U_FMB_Handel_Perfil === 3 || (seller.U_FMB_Handel_Perfil === 5 && user.U_FMB_AutorizarBoni === "1") || (seller.U_FMB_Bonificaciones === "1")
                                // seller.U_FMB_Handel_Perfil === 3 && seller.firstName === "Ericka" && seller.lastName === "Huarocc")
                                    ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goPromocionales()}>
                                        <span> Bonificaciones </span>
                                    </li>
                                    : "" : ""
                                }
                                {seller ? seller.U_FMB_Handel_Perfil === 1 && seller.U_FMB_CanalModerno === "1"  //&& user.CardName === "Julio Falcón" 
                                    ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goCanalModerno()}>
                                        <span> Canal Moderno </span>
                                    </li>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil === 1 && seller.U_FMB_CanalModerno === "1"  
                                    ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goDocumentsCreatedCM()}>
                                        <span> Documentos Creados CM </span>
                                    </li>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil === 5
                                    ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAutorizaciones()}>
                                        {/* <span> {usuario === 167 || usuario === 208 || usuario === 206 ? 'Autorización de Transferencia Gratuita' : 'Autorización de Pedidos'}</span> */}
                                        <span> Operaciones por Aprobar</span>
                                    </li>
                                    : "" : ""
                                }
                                {seller ? seller.U_FMB_Registro_Pedidos === 'Y'
                                    ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goRegistroPedidos()}>
                                        {/* <span> {usuario === 167 || usuario === 208 || usuario === 206 ? 'Autorización de Transferencia Gratuita' : 'Autorización de Pedidos'}</span> */}
                                        <span>Registro de Pedidos</span>
                                    </li>
                                    : "" : ""
                                }  
                                
                                {/* {config.aboutUs.active &&
                                    <li className="nav-link nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAboutUs()}>
                                        <span> ¿Quiénes somos? </span>
                                    </li>}
                                {config.contactUs.active &&
                                    <li className="nav-link nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goContactUs()}>
                                        <span> Contacto </span>
                                    </li>} */}
                               {config.questions.active &&
                                   <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goQuestions()}>
                                       <span> Preguntas frecuentes </span>
                                   </li>}
                               {config.claim.active &&
                                   <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goClaim()}>
                                       <span>Reclamos</span>
                                   </li>}
                               {config.termPage.active &&
                                   <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goPolitics()}>
                                       <span> Términos de uso </span>
                                   </li>}   
                            </ul>
                        </div>
                    </nav>
                </div>
                <div className='d-12 d-none d-lg-flex' style={{ width: '100%', height: 45, background: config.navBar.backgroundColor }}>
                    <nav className="navbar navbar-expand-md navbar-light navbar-two" style={{
                        paddingBottom: 8,
                        width: '100%',
                        background: config.navBar.backgroundColor 
                    }}>
                        <div className="d-none d-lg-block col-md-12" style={{ padding: 0 }}>
                            <ul className="navbar-nav mr-auto justify-content-center">
                                {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
                                    ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAutoGestCartsSaved()}>
                                        <span> Autogestión Clientes </span>
                                    </li>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
                                    ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goCartsSaved()}>
                                        <span> Guardados </span>
                                    </li>
                                    : "" : ""
                                }
                                
                                {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
                                    ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goOrderStatus()}>
                                        <span> Mis pedidos </span>
                                    </li>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
                                   ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goSelectClient()}>
                                       <span> Mis clientes </span>
                                   </li>
                                   : "" : ""
                                }
                                
                                {seller ? seller.U_FMB_Handel_Perfil === 3 || (seller.U_FMB_Handel_Perfil === 5 && user.U_FMB_AutorizarBoni === "1") || (seller.U_FMB_Bonificaciones === "1")
                                //(seller.U_FMB_Handel_Perfil === 3 && seller.firstName === "Ericka" && seller.lastName === "Huarocc")
                                   ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goPromocionales()}>
                                       <span> Bonificaciones </span>
                                   </li>
                                   : "" : ""
                               }

                               {seller ? seller.U_FMB_Handel_Perfil === 1 && seller.U_FMB_CanalModerno === "1"
                                    ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goCanalModerno()}>
                                        <span> Canal Moderno </span>
                                    </li>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil === 1 && seller.U_FMB_CanalModerno === "1"
                                    ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goDocumentsCreatedCM()}>
                                        <span> Documentos Creados CM </span>
                                    </li>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil === 5
                                   ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAutorizaciones()}>
                                       {/* <span> {usuario === 167 || usuario === 208 || usuario === 206 ? 'Autorización de Transferencia Gratuita' : 'Autorización de Pedidos'} </span> */}
                                       <span>Operaciones por Aprobar</span>
                                   </li>
                                   : "" : ""
                                }
                                {seller ? seller.U_FMB_Registro_Pedidos === 'Y'
                                    ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goRegistroPedidos()}>
                                        {/* <span> {usuario === 167 || usuario === 208 || usuario === 206 ? 'Autorización de Transferencia Gratuita' : 'Autorización de Pedidos'}</span> */}
                                        <span>Registro de Pedidos</span>
                                    </li>
                                    : "" : ""
                                }
                               
                               {config.aboutUs.active &&
                                   <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAboutUs()}>
                                       <span> ¿Quiénes somos? </span>
                                   </li>}
                               {config.contactUs.active &&
                                   <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goContactUs()}>
                                       <span> Contáctanos </span>
                                   </li>}
                               {config.questions.active &&
                                   <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goQuestions()}>
                                       <span> Preguntas frecuentes </span>
                                   </li>}
                               {config.claim.active &&
                                   <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goClaim()}>
                                       <span>Reclamos</span>
                                   </li>}
                               {config.termPage.active &&
                                   <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goPolitics()}>
                                       <span> Términos de uso </span>
                                   </li>}
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>

            //<div style={{ width: '100%', height: 90, zIndex: 95, background: 'transparent', margin: 0, marginTop: 8 }}>
            //    <div className='d-block d-md-none' style={{ width: '100%', height: 90, background: config.navBar.backgroundColor }}>
            //        <nav className="navbar navbar-expand-md navbar-light navbar-two" style={{ paddingTop: 50, background: config.navBar.backgroundColor }}>
            //            <ul className="navbar-nav mr-auto">
            //            </ul>
            //            <NavBarButton iconColor={config.navBar.iconColor} icon={config.icons.menu} style={{ fontsize: 25 }} />
            //            <div className="collapse navbar-collapse" id="navbarSupportedContent1">
            //                {sessionReducer.role === ROLES.PUBLIC ? this.renderPublicOptionMenu() : this.renderClientOptionMenu()}
            //                <ul className="navbar-nav mr-auto">
            //                    {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
            //                        ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goSelectClient()}>
            //                            <span> Mis clientes </span>
            //                        </li>
            //                        : "" : ""
            //                    }
            //                    {seller ? seller.U_FMB_Handel_Perfil === 3 || (seller.U_FMB_Handel_Perfil === 5 && user.U_FMB_AutorizarBoni === "1") || (seller.U_FMB_Handel_Perfil === 3 && seller.firstName === "Ericka" && seller.lastName === "Huarocc")
            //                        ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goPromocionales()}>
            //                            <span> Bonificaciones </span>
            //                        </li>
            //                        : "" : ""
            //                    }
            //                    {seller ? seller.U_FMB_Handel_Perfil === 5
            //                        ? <li className="nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAutorizaciones()}>
            //                            <span> TRANSFERENCIA GRATUITA </span>
            //                        </li>
            //                        : "" : ""
            //                    }
                              //  {config.aboutUs.active &&
                              //     <li className="nav-link nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAboutUs()}>
                              //         <span> ¿Quiénes somos? </span>
                              //     </li>}
                              // {config.contactUs.active &&
                              //     <li className="nav-link nav-item" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goContactUs()}>
                              //         <span> Contacto </span>
                              //     </li>} 
           //                    {config.questions.active &&
           //                        <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goQuestions()}>
           //                            <span> Preguntas frecuentes </span>
           //                        </li>}
           //                    {config.claim.active &&
           //                        <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goClaim()}>
           //                            <span>Reclamos</span>
           //                        </li>}
           //                    {config.termPage.active &&
           //                        <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goPolitics()}>
           //                            <span> Términos de uso </span>
           //                        </li>}
           //                </ul>
           //            </div>
           //        </nav>
           //    </div>
           //    <div className='d-12 d-none d-md-flex' style={{ width: '100%', height: 90, background: config.navBar.backgroundColor }}>
           //        <nav className="navbar navbar-expand-md navbar-light navbar-two" style={{
           //            paddingBottom: 10,
           //            width: '100%',
           //            paddingTop: 50,
           //            background: config.navBar.backgroundColor
           //        }}>
           //            <div className="d-none d-md-block col-md-6" style={{ padding: 0 }}>
           //                <ul className="navbar-nav mr-auto">
           //                    {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5
           //                        ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goSelectClient()}>
           //                            <span> Mis clientes </span>
           //                        </li>
           //                        : "" : ""
           //                    }
           //                    {seller ? seller.U_FMB_Handel_Perfil === 3 || (seller.U_FMB_Handel_Perfil === 5 && user.U_FMB_AutorizarBoni === "1")
           //                        ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goPromocionales()}>
           //                            <span> Bonificaciones </span>
           //                        </li>
           //                        : "" : ""
           //                    }
           //                    {seller ? seller.U_FMB_Handel_Perfil === 5
           //                        ? <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAutorizaciones()}>
           //                            <span> TRANSFERENCIA GRATUITA </span>
           //                        </li>
           //                        : "" : ""
           //                    }
           //                    {config.aboutUs.active &&
           //                        <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goAboutUs()}>
           //                            <span> ¿Quiénes somos? </span>
           //                        </li>}
           //                    {config.contactUs.active &&
           //                        <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goContactUs()}>
           //                            <span> Contáctanos </span>
           //                        </li>}
           //                    {config.questions.active &&
           //                        <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goQuestions()}>
           //                            <span> Preguntas frecuentes </span>
           //                        </li>}
           //                    {config.claim.active &&
           //                        <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goClaim()}>
           //                            <span>Reclamos</span>
           //                        </li>}
           //                    {config.termPage.active &&
           //                        <li className="nav-link" style={{ color: config.navBar.textColor, cursor: 'pointer' }} onClick={() => history.goPolitics()}>
           //                            <span> Términos de uso </span>
           //                        </li>}
           //                </ul>
           //            </div>
           //        </nav>
           //    </div>
           //</div>
        );
    };


    render() {
        return (
            
            <div>
                <MenuCategories />
                <LoginRegisterModal />
                <LoginModal />

                <div className="fixed-top" style={{ background: config.navBar.backgroundColor }}>
                    {this.renderFirstNavBar()}
                    {this.renderSecondNavBar()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { itemsReducer: store.ItemsReducer, sessionReducer: store.SessionReducer, configReducer: store.ConfigReducer };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavBar);
